export default __webpack_public_path__ + "static/media/slack_logo.044efd1b.svg";